import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRightIcon, MountainSnowIcon, UtensilsIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { LocationCards } from "../components/LocationCards";
import { useSite } from "../context/SiteContext";
const HOME_BACKGROUND = "https://cdn.magicpatterns.com/uploads/wk6Bwx4nrP4caACt6R4SpH/2026-08-19-14-56-02-688.png";
export function HomePage() {
  const {
    t
  } = useSite();
  const reduceMotion = useReducedMotion();
  return <>
      <section className="relative min-h-[720px] overflow-hidden bg-cocoa bg-cover bg-center text-ivory sm:min-h-[760px]" style={{
      backgroundImage: `url("${HOME_BACKGROUND}")`
    }} data-id="element-298" data-mp="2s2z6ueew2qnl">
        <div className="absolute inset-0 bg-cocoa/72" data-id="element-299" data-mp="31y0xjeotc0sa" />
        <motion.div initial={reduceMotion ? undefined : {
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7
      }} className="relative mx-auto flex min-h-[720px] max-w-7xl items-center px-4 py-20 sm:min-h-[760px] sm:px-6" data-id="element-300" data-mp="2e9hlqp6k15vg">
          <div className="max-w-3xl" data-id="element-301" data-mp="2epyizgxumzvw">
            <p className="mb-6 text-xs font-bold uppercase tracking-[.3em] text-gold" data-id="element-302" data-mp="2eox75a90e9d4">
              {t("Two Locations. One Family.", "Dos ubicaciones. Una familia.")}
            </p>
            <h1 className="max-w-3xl font-serif text-5xl font-semibold leading-[.98] text-ivory sm:text-7xl lg:text-[88px]" data-id="element-303" data-mp="2of8fd8zq74pt">
              {t("Authentic Mexican Food in the Heart of Teton Valley", "Comida mexicana auténtica en el corazón de Teton Valley")}
            </h1>
            <p className="mt-7 max-w-2xl text-base leading-7 text-ivory/85 sm:text-lg" data-id="element-304" data-mp="20pdzsjo0v21v">
              {t("Visit Agave in Driggs or Blue Agave in Victor for family-style hospitality, sizzling fajitas, flavorful sauces, seafood specialties, and handcrafted cocktails.", "Visita Agave en Driggs o Blue Agave en Victor y disfruta hospitalidad familiar, fajitas calientes, salsas llenas de sabor, especialidades de mariscos y cócteles artesanales.")}
            </p>
            <div className="mt-9 flex flex-wrap gap-3" data-id="element-305" data-mp="2mjt561uzj9dc">
              <a href="#locations" className="inline-flex min-h-12 items-center gap-2 rounded-full bg-mexicanred px-6 font-bold text-white transition-colors hover:bg-[#6B0000] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-306" data-mp="31dy1anoswrqj">
                {t("Choose Your Location", "Elige tu ubicación")}
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-307" data-mp="2ig4yrmi3ajto" />
              </a>
              <Link to="/menus" className="inline-flex min-h-12 items-center rounded-full border border-ivory/35 bg-black/10 px-6 font-bold text-ivory transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-308" data-mp="2ihy3uxd20vzk">
                {t("View Menus", "Ver menús")}
              </Link>
            </div>
          </div>
        </motion.div>
        <div className="absolute bottom-0 left-0 hidden border-r border-t border-ivory/15 bg-cocoa/70 px-8 py-5 backdrop-blur sm:block" data-id="element-309" data-mp="59xa35p4ym6i">
          <p className="text-[10px] uppercase tracking-[.28em] text-ivory/70" data-id="element-310" data-mp="3mrhucjug5ues">
            Driggs · Victor · Idaho
          </p>
        </div>
      </section>

      <section id="locations" className="scroll-mt-24 bg-ivory px-4 py-20 sm:px-6 sm:py-28" data-id="element-311" data-mp="j8ol2j8pbrqf">
        <div className="mx-auto max-w-7xl" data-id="element-312" data-mp="o8t1k99m0mgn">
          <div className="mb-12 max-w-2xl" data-id="element-313" data-mp="o7rfl9r22fk5">
            <p className="eyebrow" data-id="element-314" data-mp="a8s0aspfnd0n">{t("Find your table", "Encuentra tu mesa")}</p>
            <h2 className="section-title" data-id="element-315" data-mp="aaumt2rdmo0m">
              {t("Two kitchens. One warm welcome.", "Dos cocinas. Una cálida bienvenida.")}
            </h2>
          </div>
          <LocationCards data-id="element-316" data-mp="2ux6029r8q4mx" />
        </div>
      </section>

      <section className="border-t border-sand/30 bg-ivory px-4 py-20 sm:px-6 sm:py-28" data-id="element-317" data-mp="2z0u78rbymy7n">
        <div className="mx-auto max-w-5xl text-center" data-id="element-318" data-mp="3f775jhulw38j">
          <MountainSnowIcon className="mx-auto h-9 w-9 text-terracotta" aria-hidden="true" data-id="element-319" data-mp="3f91ud7900fhw" />
          <p className="eyebrow mt-5" data-id="element-320" data-mp="3af5ycacap2pd">{t("Eat well. Wander far.", "Come bien. Explora más.")}</p>
          <h2 className="section-title mx-auto max-w-4xl" data-id="element-321" data-mp="35i747rsmsvr6">
            {t("Exploring Teton Valley? Make Agave Part of the Journey.", "¿Explorando Teton Valley? Haz de Agave parte del viaje.")}
          </h2>
          <p className="mx-auto mt-6 max-w-3xl leading-8 text-charcoal/70" data-id="element-322" data-mp="3t7hxko7njnva">
            {t("Between scenic drives, days at Grand Targhee, and mountain adventures near the Grand Teton area, join us in Driggs or Victor. We welcome locals and visitors traveling from Jackson Hole for skiing, hiking, biking, and time together around the table.", "Entre recorridos panorámicos, días en Grand Targhee y aventuras cerca del área de Grand Teton, visítanos en Driggs o Victor. Recibimos a residentes y visitantes de Jackson Hole que vienen a esquiar, caminar, andar en bicicleta y compartir alrededor de la mesa.")}
          </p>
          <Link to="/locations" className="mt-8 inline-flex min-h-12 items-center gap-2 rounded-full bg-mexicangreen px-6 font-bold text-white transition-colors hover:bg-[#005036]" data-id="element-323" data-mp="sb7l43hth6fb">
            <UtensilsIcon className="h-4 w-4" aria-hidden="true" data-id="element-324" data-mp="122lkmb9rq68g" />
            {t("Plan your visit", "Planea tu visita")}
          </Link>
        </div>
      </section>
    </>;
}